import { render, staticRenderFns } from "./leftSideBar.vue?vue&type=template&id=478610c4&scoped=true"
import script from "./leftSideBar.vue?vue&type=script&lang=js"
export * from "./leftSideBar.vue?vue&type=script&lang=js"
import style0 from "./leftSideBar.vue?vue&type=style&index=0&id=478610c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478610c4",
  null
  
)

export default component.exports